import * as React from 'react';
import ReactDOM from 'react-dom';

import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Label } from 'office-ui-fabric-react/lib/Label';

import { DialogBox } from './DialogBox.js';

import { Config } from '../Config.js';
import { Session } from './Session.js';
import { Utils } from './Utils.js';
import { Paypal } from '../Paypal.js';
import { PdfFromApi } from './PdfFromApi.js';

import pdficon from '../icons/pdf32.png';
import gasicon from '../icons/gas32.png';
import eeicon from '../icons/ee32.png';
import docicon from '../icons/doc32.png';
import csvicon from '../icons/csv32.png';

const sessione = new Session();
const config = new Config();
const utils = new Utils();
const pdffromapi = new PdfFromApi();

export class Azioni extends React.Component  {

    constructor() {
        super();
        this.state = {
            elemento : false,
        };

        this.scaricaPdf = this.scaricaPdf.bind(this);
    }

    componentDidMount() { /* questa classe non viene renderizzata .... */ }

    downloadFileDaBlob(blob , filename) {

        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE doesn't allow using a blob object directly as link href.
            // Workaround for "HTML7007: One or more blob URLs were
            // revoked by closing the blob for which they were created.
            // These URLs will no longer resolve as the data backing
            // the URL has been freed."
            window.navigator.msSaveBlob(blob, filename);
            return;
        }

        var a = document.createElement('a');
        a.style = "display: none";  
        //var blob = new Blob([data], {type: "application/octet-stream"});
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        //window.URL.revokeObjectURL(url);
        
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(url);
        }, 100);
    }

    selezionaUtente(id_cliente){
        sessione.set('id_cliente' , id_cliente );
        
        // ricarico AC2 passando da home.js
        window.location.reload();
    }

    scaricaDoc( id_allegato , tipo , filename)
    {
        let request = new Request( config.get("utility_scaricafile"),{
            method: 'POST', mode: 'cors', credentials: "include" ,
            body: JSON.stringify({id_allegato:id_allegato , tipo:tipo , id_cliente: sessione.get('id_cliente') })
        });
        
        fetch(request)
        .then(function(response){
            return response.blob();
        }).then(function(blob){
            //console.log(blob.size);
            //console.log(blob.type);

            if( blob.type === 'application/json' )
            { 
                this.apriDialogBox( 'avviso' , { 'titolo':'Errore nello scarico del Documento' , 'testo':'Se non riesci a scaricare i tuoi documenti, richiedi informazioni'} );
            }
            else
            {
                this.downloadFileDaBlob(blob, filename );
            }
                
        }.bind(this) )
    }

    scaricaPdf(numerodocumento , tipo , path , testopre='' ){

        let request = new Request( config.get("utility_scaricafile"),{
            method: 'POST', mode: 'cors', credentials: "include" ,
            body: JSON.stringify({path: path , tipo:tipo , id_cliente: sessione.get('id_cliente') })
        });
        
        
        fetch(request)
        .then(function(response){
            return response.blob();
        }).then(function(blob){
            //console.log(blob.size);
            //console.log(blob.type);
            
            if( blob.type !== 'application/octet-stream' && blob.type !== 'application/pdf' )
            { 
                this.apriDialogBox( 'avviso' , { 'titolo':'Errore nello scarico del PDF' , 'testo':'Se non riesci a scaricare i tuoi documenti, richiedi informazioni'} );
            }
            else
            {
                let nomedocpdf = numerodocumento+'.pdf';
                
                if( testopre !== '' ) nomedocpdf = testopre+'_'+nomedocpdf;
                
                this.downloadFileDaBlob(blob, nomedocpdf );
            }
        }.bind(this) )
    }

    
    scaricaZip(numerodocumento , tipo , path , testopre='' ){

        let request = new Request( config.get("utility_scaricafile"),{
            method: 'POST', mode: 'cors', credentials: "include" ,
            body: JSON.stringify({path: path , tipo:tipo , id_cliente: sessione.get('id_cliente') })
        });
        
        
        fetch(request)
        .then(function(response){
            return response.blob();
        }).then(function(blob){
            // console.log(blob.size);
            // console.log(blob.type);

            if( blob.type !== 'application/zip' )
            { 
                this.apriDialogBox( 'avviso' , { 'titolo':'Errore nello scarico del FILE' , 'testo':'Se non riesci a scaricare i tuoi documenti, richiedi informazioni'} );
            }
            else
            {
                let nomedoczip = numerodocumento+'.zip';
                
                if( testopre !== '' ) nomedoczip = testopre+'_'+nomedoczip;
                
                this.downloadFileDaBlob(blob, nomedoczip );
            }

        }.bind(this) )
    }
    
    scaricaDocumento(filename){

        let request = new Request( config.get("utility_scaricafile"),{
            method: 'POST', mode: 'cors', credentials: "include" ,
            body: JSON.stringify({entry: filename , id_cliente: sessione.get('id_cliente') })
        });
        
        
        fetch(request)
        .then(function(response){
            return response.blob();
        }).then(function(blob){
            //console.log(blob.size);
            //console.log(blob.type);

            if( blob.type === 'application/json' )
            { 
                this.apriDialogBox( 'avviso' , { 'titolo':'Errore nello scarico del Documento' , 'testo':'Se non riesci a scaricare i tuoi documenti, richiedi informazioni'} );
            }
            else
            {
                this.downloadFileDaBlob(blob, filename );
            }
        
        }.bind(this) )
    }
    
    apriDialogBox( tipo , item )
    {
        ReactDOM.unmountComponentAtNode(document.getElementById('boxdialogo'));
        ReactDOM.render(<DialogBox tipo={tipo} elemento={item} />, document.getElementById('boxdialogo'));
    }
    
    restituisciAnni()
    {
        return [
            { key: '2010', text: '2010'},
            { key: '2011', text: '2011'},
            { key: '2012', text: '2012'},
            { key: '2013', text: '2013'},
            { key: '2014', text: '2014'},
            { key: '2015', text: '2015'},
            { key: '2016', text: '2016'},
            { key: '2017', text: '2017'},
            { key: '2018', text: '2018'}
        ];
    }
    
    restituisciMesi()
    {
        return [
            { key: '1', text: 'Gennaio'},
            { key: '2', text: 'Febbraio'},
            { key: '3', text: 'Marzo'},
            { key: '4', text: 'Aprile'},
            { key: '5', text: 'Maggio'},
            { key: '6', text: 'Giugno'},
            { key: '7', text: 'Luglio'},
            { key: '8', text: 'Agosto'},
            { key: '9', text: 'Settembre'},
            { key: '10', text: 'Ottobre'},
            { key: '11', text: 'Novembre'},
            { key: '12', text: 'Dicembre'}
        ];
    }
    
    restituisciColonneRegistri()
    {
        var cols =[];
    
        cols.push({key: 'mese', name: 'Mese',fieldName: 'periodo', minWidth: 90, maxWidth: 110, isResizable: false });
        cols.push({key: 'um', name: 'U.M.', fieldName: 'um', minWidth: 50, maxWidth:50 , isResizable: true });
        cols.push({key: 'f1', name: 'F1', fieldName: 'f1', minWidth: 40, maxWidth: 40, isResizable: false });
        cols.push({key: 'f2', name: 'F2', fieldName: 'f2', minWidth: 40, maxWidth: 40, isResizable: false });
        cols.push({key: 'f3', name: 'F3', fieldName: 'f3', minWidth: 40, maxWidth: 40, isResizable: false });
        cols.push({key: 'mono', name: 'Monoraria', fieldName: 'mono', minWidth: 40, maxWidth: 70, isResizable: false, className : 'nascondisotto560', headerClassName : 'nascondisotto560' });
        cols.push({key: 'picco', name: 'Picco', fieldName: 'picco', minWidth: 40, maxWidth: 70, isResizable: false, className : 'nascondisotto560', headerClassName : 'nascondisotto560' });
        cols.push({key: 'fuoripicco', name: 'Fuoripicco', fieldName: 'fuori', minWidth: 40, maxWidth: 90, isResizable: false, className : 'nascondisotto560', headerClassName : 'nascondisotto560' });
 
        return cols;
    }

    
    restituisciColonneRegistriGas()
    {
        var cols =[];
    
        cols.push({key: 'mese', name: 'Mese',fieldName: 'MESE', minWidth: 60, maxWidth: 60, isResizable: false });
        cols.push({key: 'cnc', name: 'Consumo non Corretto.', fieldName: 'VAL_ENERGIA', minWidth: 170, maxWidth:170 , isResizable: true });
        cols.push({key: 'cc', name: 'Consumo Corretto', fieldName: 'VAL_ENERGIA_CORRETTO', minWidth: 130, maxWidth: 130, isResizable: false, className : 'nascondisotto560', headerClassName : 'nascondisotto560' });
        cols.push({key: 'priorita', name: 'Priorità', fieldName: 'DES_PRIORITA_LETTURA', minWidth: 70, maxWidth: 70, isResizable: false });
        cols.push({key: 'fattorec', name: 'Fattore C', fieldName: 'VAL_FATTORE_C', minWidth: 70, maxWidth: 70, isResizable: false, className : 'nascondisotto560', headerClassName : 'nascondisotto560' });
 
        return cols;
    }
    
    restituisciColonneDettaglioGas()
    {
        var cols =[];
    
        cols.push({key: 'mese', name: 'Mese',fieldName: 'DATA_MISURA', minWidth: 80, maxWidth: 80, isResizable: false });
        cols.push({key: 'cnc', name: 'Consumo Giornaliero   non Corretto.', fieldName: 'VAL_ENERGIA', minWidth: 150, maxWidth:150 , isResizable: true, className : 'mostratutto', headerClassName : 'mostratutto' });
        cols.push({key: 'cc', name: 'Priorità', fieldName: 'DES_PRIORITA_LETTURA', minWidth: 80, maxWidth: 80, isResizable: false });
 
        return cols;
    }
    
    
    restituisciColonneRichieste()
    {
        var cols =[];
    
        cols.push({key: 'coldata', name: 'Data',fieldName: 'DATA', minWidth: 70, maxWidth: 70, isResizable: false });
        cols.push({key: 'tiporichiesta', name: 'Tipo Richiesta', fieldName: 'TIPO_RICHIESTA', minWidth: 200, maxWidth: 500 , isResizable: true, className : 'mostratutto', headerClassName : 'mostratutto'  });
        cols.push({key: 'statorichiesta', name: 'Stato', fieldName: 'STATO_RICHIESTA', minWidth: 50, maxWidth: 50, isResizable: false, className : 'nascondisotto400', headerClassName : 'nascondisotto400' });
        cols.push({key: 'dataevasione', name: 'Evasione', fieldName: 'DATA_EVASIONE', minWidth: 70, maxWidth: 70, isResizable: false, className : 'nascondisotto960', headerClassName : 'nascondisotto960' });
 
        return cols;
    }
    
    restituisciColonneContratti()
    {
        var cols =[];
    
        cols.push({key: 'colpod', name: 'Pod',fieldName: 'POD', minWidth: 160, maxWidth: 160, isResizable: false });
        cols.push({key: 'codcontratto', name: 'Cod. Contratto', fieldName: 'CODICE_CONTRATTO', minWidth: 100, maxWidth: 100 , isResizable: false });
        cols.push({key: 'validità', name: 'Validità', minWidth: 80, maxWidth: 160, isResizable: true, className : 'mostratutto', headerClassName : 'mostratutto' ,
            onRender: (item) => {
                return 'dal '+item.INIZIO_VALIDITA + ' al ' + item.FINE_VALIDITA
            }
        });
        cols.push({key: 'stato', name: 'Stato', fieldName: 'STATO_CONTRATTO', minWidth: 70, maxWidth: 70, isResizable: false, className : 'nascondisotto560', headerClassName : 'nascondisotto560' });
 
        return cols;
    }
    
    restituisciColonneUtenti()
    {
        let ID_AMMINISTRATORE = sessione.get('id_amministratore');

        var cols =[];
        cols.push({key: 'seleziona', name: '', minWidth: 24, maxWidth: 24, isResizable: false, className : 'mostratutto', headerClassName : 'mostratutto' , 
            onRender: (item) => {
                return <div onClick={() => this.selezionaUtente( item.ID_CLIENTE )} alt="Seleziona Utenza" title="Seleziona Utenza" >
                    <IconButton className='bottoneImmagineUser' iconProps={{ iconName: 'UserFollowed' }} /></div>
            }
        });
        cols.push({key: 'codcliente', name: 'Codice',fieldName: 'COD_CLIENTE', minWidth: 80, maxWidth: 100, isResizable: false, className : 'nascondisotto400', headerClassName : 'nascondisotto400' });
        
        if(ID_AMMINISTRATORE>0){   
            cols.push({key: 'colragsoc', name: 'Condominio', minWidth: 300, maxWidth: 450, isResizable: false , onRender: (item) => {
                    return <div><Label className="itemUtente">{item.RAGIONE_SOCIALE}</Label><Label className="itemUtente">{item.INDIRIZZO}</Label></div>
                }
            });
        }else{
            cols.push({key: 'colragsoc', name: 'Utente', minWidth: 300, maxWidth: 450, isResizable: false , onRender: (item) => {
                    return <div><Label className="itemUtente">{item.RAGIONE_SOCIALE}</Label><Label className="itemUtente">{item.INDIRIZZO}</Label></div>
                }
            });
        }
        
        return cols;
    }
    
    
    restituisciColonneDocumenti()
    {
        var cols =[];

        cols.push({key: 'icona', name: '', minWidth: 24, maxWidth: 24, className : 'nascondisotto400', headerClassName : 'centrato nascondisotto400', alt:"Scarica Doc", isResizable: false,
            onRender: (item) => {
                if(item.TIPO === "E") { return <div onClick={()=>this.scaricaDoc(item.ID_ALLEGATO , item.TIPO , item.NOMEREALE ) }><img className="c-pointer w24" src={eeicon} alt="Doc EE" title="Doc EE" /></div>; }
                else { return <div onClick={()=>this.scaricaDoc(item.ID_ALLEGATO , item.TIPO , item.NOMEREALE ) }><img className="c-pointer w24" src={gasicon} alt="Doc GAS" title="Doc GAS" /></div>; }
            }
        });
        
        cols.push({key: 'icona', name: '', minWidth: 24, maxWidth: 24, className : '', headerClassName : 'centrato', alt:"Scarica Doc", isResizable: false,
            onRender: (item) => {
                if(item.TIPOMIME === "application/pdf") {
                    return <div onClick={()=>this.scaricaDoc(item.ID_ALLEGATO , item.TIPO , item.NOMEREALE ) }><img className="c-pointer" src={pdficon} alt="Scarica Doc" title="Scarica PDF" /></div>;
                }
                else
                {
                    return <div onClick={()=>this.scaricaDoc(item.ID_ALLEGATO , item.TIPO , item.NOMEREALE ) }><img className="c-pointer" src={docicon} alt="Scarica Doc" title="Scarica Doc" /></div>;
                }
            }
        });
        
        cols.push({key: 'CODICE_CONTRATTO', name: 'Contratto',fieldName: 'CODICE_CONTRATTO', minWidth: 70, maxWidth: 100, isResizable: false });

        cols.push({key: 'NOME_TIPO_ALLEGATO', name: 'Tipo',fieldName: 'NOME_TIPO_ALLEGATO', minWidth: 70, maxWidth: 200, isResizable: false , className : 'mostratutto nascondisotto400', headerClassName : 'mostratutto nascondisotto400' });

        cols.push({key: 'NOMEREALE', name: 'Nome',fieldName: 'NOMEREALE', minWidth: 200, maxWidth: 500, isResizable: true });
       
        cols.push({key: 'data', name: 'Data', minWidth: 80, maxWidth: 80, isResizable: false, className : 'mostratutto nascondisotto400', headerClassName : 'mostratutto nascondisotto400' ,
            onRender: (item) => {
                return item.DATA_UPLOAD.substring(0,10);
            }
        });
        
        return cols;
    }
    
    restituisciColonneModuli()
    {
        var cols =[];
    
        cols.push({key: 'validità', name: '', minWidth: 30, maxWidth: 30, isResizable: false ,
            onRender: (item) => {
                if( ( item.filename.toLowerCase().indexOf('pdf') >-1) ){
                    return <div onClick={()=>this.scaricaDocumento(item.filename) }><img className="c-pointer" src={pdficon} alt="Scarica Modulo" title="Scarica Modulo" /></div>;
                }
                else
                {
                    return <div onClick={()=>this.scaricaDocumento(item.filename) }><img className="c-pointer" src={docicon} alt="Scarica Modulo" title="Scarica Modulo" /></div>;
                }
            }
        });
        cols.push({key: 'filename', name: 'File', fieldName: 'filename', minWidth: 200, maxWidth: 400 , isResizable: true, className : 'mostratutto', headerClassName : 'mostratutto' });
 
        return cols;
    }
    
    restituisciColonneFatture( visualizza )
    {
        
        if ( typeof visualizza === "undefined" ) { visualizza = {}; }
        
        //console.log( 'ABILITAZIONI BOTTONI : ',visualizza );
        
        var cols =[];
    
        cols.push({key: 'coltipo', name: '', fieldName: 'TIPO', minWidth: 18, maxWidth: 18, isResizable: false,
            onRender: (item) => {
                if(item.TIPO === 'E') { return <img className='iconatipo' src={eeicon} alt="Fattura Energia Elettrica" title="Fattura Energia Elettrica" />; }
                if(item.TIPO === 'G') { return <img className='iconatipo' src={gasicon} alt="Fattura Gas" title="Fattura Gas" />; }
            }
        });
    
        let wcolfattura = 135;
        let settaggio = utils.getObjInfoSocieta( 'NUM_FATTURA_STRETTA' , false );
        if( settaggio !== false && settaggio !== '' && settaggio !== 'null' && settaggio !== null && settaggio === 'SI' ) {  
            wcolfattura = 80;
        }
    
        cols.push({key: 'colnum', name: 'Num. fattura',  minWidth: wcolfattura, maxWidth: wcolfattura, isResizable: false,
            onRender: (item) => { return <TooltipHost content={item.NUMERO_DOCUMENTO} calloutProps={{ gapSpace: 0 }}>{item.NUMERO_DOCUMENTO}</TooltipHost> }
        });
        cols.push({key: 'colemissione', name: 'Emissione', fieldName: 'EMISSIONE', minWidth: 75, maxWidth: 75, isResizable: false });
        
        cols.push({key: 'colpod', name: 'Sito', fieldName: 'SITO', minWidth: 100, maxWidth: 140, isResizable: true, className : 'nascondisotto760', headerClassName : 'nascondisotto760',
            onRender: (item) => { return <TooltipHost content={item.SITO} calloutProps={{ gapSpace: 0 }}>{item.SITO}</TooltipHost> }
        });
        
        
        cols.push({key: 'colscadenza', name: 'Scadenza', fieldName: 'SCADENZA', minWidth: 65, maxWidth: 65, isResizable: false, className : 'nascondisotto560', headerClassName : 'nascondisotto560' });
        
        /** ticket #41921 **/
        
        let ID_AGGREGATO = sessione.get('id_aggregato');
        
        if( utils.getObjInfoSocieta( 'VEDI_DATA_PAGAMENTO' , true ) === 'Tutti' ||
            (utils.getObjInfoSocieta( 'VEDI_DATA_PAGAMENTO' , true ) === 'Aggregati' && ( ID_AGGREGATO !== '' && ID_AGGREGATO !== 0 && ID_AGGREGATO !== null ) )
         ){
            cols.push({key: 'DataPagamento', name: 'Pagamento', minWidth: 65, maxWidth: 65, className : 'nascondisotto560', headerClassName : 'nascondisotto560',
                onRender: (item) => {
                    if('DATA_PAGAMENTO' in item && item.DATA_PAGAMENTO !== false) {
                        return item.DATA_PAGAMENTO;
                    }
                }
            });
        }
        
        
        cols.push({key: 'colconsumo', name: 'Consumo Dal-Al', minWidth: 135, maxWidth: 135, isResizable: false, className:'nascondisotto960', headerClassName:'nascondisotto960',
            onRender: (item) => { return item.CONSUMI_DAL + ' - ' + item.CONSUMI_AL; }
        });
        
        
        // qui devo incastrare CANONE RAI , TOTALE , NEW_TOT_REALE
        
        cols.push({key: 'coltotfatt', name: 'Tot Fattura', fieldName: 'TOTALE', minWidth: 70, maxWidth: 70, isResizable: false, className : 'nascondisotto400 centrato', headerClassName : 'nascondisotto400 centrato',
            onRender: (item) => { 
                return utils.euroFormat(item.TOTALE);
            }
        });
        cols.push({key: 'colcrai', name: 'Rai',  minWidth: 45, maxWidth: 45, isResizable: false, className : 'nascondisotto960 centrato', headerClassName : 'nascondisotto960 centrato',
            onRender: (item) => { 
                if( item.IMPORTO_CANONE_RAI !== '' && item.IMPORTO_CANONE_RAI !== null ){ return utils.euroFormat(item.IMPORTO_CANONE_RAI); } else { return '-'; }
            }
        });
        
        // #48347 - cambiare nome colonna se pagamento COLONNA_SALDO_ALT e' valorizzato
        let nomeDaPagare = 'Da Pagare';
        if ( utils.getObjInfoSocieta( 'COLONNA_SALDO_ALT' , '' ) !== '' && utils.getObjInfoSocieta( 'COLONNA_SALDO_ALT' , '' ) !== null ){ 
            nomeDaPagare = utils.getObjInfoSocieta( 'COLONNA_SALDO_ALT' , 'Da Pagare' );
        }
        
        cols.push({key: 'coldapagare', name: nomeDaPagare , minWidth: 70, maxWidth: 70, isResizable: false, className : 'centrato', headerClassName : 'centrato',
            onRender: (item) => { 
                
                // #48347
                // qui devo esporre diverso in base se utils.getObjInfoSocieta( 'ABILITA_PAYPAL' , true ) === 'SI'
                if ( utils.getObjInfoSocieta( 'ABILITA_PAYPAL' , 'NO' ) === 'SI' || utils.getObjInfoSocieta( 'MOSTRA_PAGAMENTO_RESIDUO' , 'NO' ) === 'SI' ){
                    if( item.PAGAMENTO_RESIDUO === '' || item.PAGAMENTO_RESIDUO === null){ return utils.euroFormat('0'); }
                    else{ return utils.euroFormat(item.PAGAMENTO_RESIDUO); }
                }else{
                    if( item.NEW_TOT_REALE !== '' && item.NEW_TOT_REALE !== null ){ return utils.euroFormat(item.NEW_TOT_REALE); } else { return utils.euroFormat(item.TOTALE); }
                }
            }
        });

        // SE PASSO DALLE API
        if( pdffromapi.loadFromApi() === true ){

            cols.push({key: 'Fattura', name: 'PDF', minWidth: 18, maxWidth: 18, className : 'VIS_FATTURA', headerClassName : 'VIS_FATTURA centrato', alt:"Scarica Fattura",
                onRender: (item) => {
                    if(item.PATH !== false) {
                        return <div onClick={()=>pdffromapi.bottonePdfApi(item) }><img className="c-pointer" src={pdficon} alt="Scarica Fattura" title="Scarica Fattura" /></div>;
                    }
                }
            });
        }
        else
        {

            if( visualizza !== null && 'FATTURA' in visualizza && visualizza['FATTURA'] !== false){
                cols.push({key: 'Fattura', name: 'F', minWidth: 18, maxWidth: 18, className : 'VIS_FATTURA', headerClassName : 'VIS_FATTURA centrato', alt:"Scarica Fattura",
                    onRender: (item) => {
                        if( 'PATH_FATTURA' in item && item.PATH_FATTURA  !== false && ( item.PATH_SINTESI === false || !('PATH_SINTESI' in item) ) ) {
                            return <div onClick={()=>this.scaricaPdf(item.NUMERO_DOCUMENTO , item.TIPO , item.PATH_FATTURA  , 'fattura') }><img className="c-pointer" src={pdficon} alt="Scarica Fattura" title="Scarica Fattura" /></div>;
                        }
                    }
                });
            }

            // if( visualizza !== null && 'DETTAGLIO' in visualizza && visualizza['DETTAGLIO'] !== false){
            // gestione da MS381_AC2_CUSTOMIZATION
            // if( utils.getInfoSocieta( 'VISUALIZZA_FATT_DETTAGLIO' , true ) === true ){

            // 1 =  Bolletta sintetica + dettaglio importi       0 = Solo bolletta sintetica
            let DB20 = utils.leggiInfoCliente('DETTAGLIO_BOLLETTA_20' , '0');

            if( visualizza !== null && 'SINTESI' in visualizza && visualizza['SINTESI'] !== false){
                cols.push({key: 'FatturaSintesi', name: 'S', minWidth: 18, maxWidth: 18, className : 'VIS_SINTESI', headerClassName : 'VIS_SINTESI centrato', alt:"Scarica Sintesi",
                    onRender: (item) => {
                        if('PATH_SINTESI' in item && item.PATH_SINTESI !== false) {
                            return <div onClick={()=>this.scaricaPdf(item.NUMERO_DOCUMENTO , item.TIPO , item.PATH_SINTESI , 'sintesi') }><img className="c-pointer" src={pdficon} alt="Scarica Sintesi" title="Scarica Sintesi" /></div>;
                        }
                    }
                });
            }

            // #46802
            if( utils.getObjInfoSocieta( 'VISUALIZZA_FATT_DETTAGLIO' , 'SI' ) === 'SI' || ( utils.getObjInfoSocieta( 'VISUALIZZA_FATT_DETTAGLIO' , 'SI' ) === 'Utente' && parseInt(DB20 , 10)===1 ) ){
                cols.push({key: 'FatturaDettaglio', name: 'D', minWidth: 18, maxWidth: 18, className : 'VIS_DETTAGLIO', headerClassName : 'VIS_DETTAGLIO centrato', alt:"Scarica Dettaglio",
                    onRender: (item) => {
                        if('PATH_DETTAGLIO' in item && item.PATH_DETTAGLIO !== false) {
                            return <div onClick={()=>this.scaricaPdf(item.NUMERO_DOCUMENTO , item.TIPO , item.PATH_DETTAGLIO , 'dettaglio') }><img className="c-pointer" src={pdficon} alt="Scarica Dettaglio" title="Scarica Dettaglio" /></div>;
                        }
                    }
                });
            }


            if( visualizza !== null && 'BOZE' in visualizza && visualizza['BOZE'] !== false){
                cols.push({key: 'FatturaBoze', name: 'B', minWidth: 18, maxWidth: 18, className : 'VIS_BOZE', headerClassName : 'VIS_BOZE centrato', alt:"Scarica Bolletta Zero",
                    onRender: (item) => {
                        if(item.PATH_BZE !== false) {
                            return <div onClick={()=>this.scaricaPdf(item.NUMERO_DOCUMENTO , item.TIPO , item.PATH_BZE , 'boze') }><img className="c-pointer" src={pdficon} alt="Scarica Bolletta Zero" title="Scarica Bolletta Zero" /></div>;
                        }
                    }
                });
            }

            if( visualizza !== null && 'BP' in visualizza && visualizza['BP'] !== false){
                cols.push({key: 'FatturaBP', name: 'Bp', minWidth: 18, maxWidth: 18, className : 'VIS_BP', headerClassName : 'VIS_BP centrato', alt:"Scarica Bollettino Postale",
                    onRender: (item) => {
                        if('PATH_BP' in item && item.PATH_BP !== false) {
                            return <div onClick={()=>this.scaricaPdf(item.NUMERO_DOCUMENTO , item.TIPO , item.PATH_BP , 'bollettino') }><img className="c-pointer" src={pdficon} alt="Scarica Bollettino Postale" title="Scarica Bollettino Postale" /></div>;
                        }
                    }
                });
            }
            
            cols.push({key: 'FatturaCSV',  minWidth: 18, maxWidth: 18, className : 'VIS_CSV', headerClassName : 'VIS_CSV centrato', alt:"Scarica CSV",
                onRender: (item) => {
                    if('PATH_CSV' in item && item.PATH_CSV !== false) {
                        return <div onClick={()=>this.scaricaZip(item.NUMERO_DOCUMENTO , item.TIPO , item.PATH_CSV , 'csv') }><img className="c-pointer" src={csvicon} alt="Scarica CSV" title="Scarica CSV" /></div>;
                    }
                }
            });

            if( visualizza !== null && 'CERT' in visualizza && visualizza['CERT'] !== false){
                cols.push({key: 'FatturaCert', name: 'C', minWidth: 18, maxWidth: 18, className : 'VIS_CERT', headerClassName : 'VIS_CERT centrato', alt:"Scarica Certificato Energia Verde",
                    onRender: (item) => {
                        if(item.PATH_CERT !== false) {
                            return <div onClick={()=>this.scaricaPdf(item.NUMERO_DOCUMENTO , item.TIPO , item.PATH_CERT , 'cert') }><img className="c-pointer" src={pdficon} alt="Scarica Certificato Energia Verde" title="Scarica Certificato Energia Verde" /></div>;
                        }
                    }
                });
            }

        }

        if( visualizza !== null && utils.getObjInfoSocieta( 'ABILITA_PAYPAL' , 'NO' ) === 'SI'
                 && utils.getObjInfoSocieta( 'MAIL_PAYPAL' , '' ) !== ''  && utils.getObjInfoSocieta( 'MAIL_PAYPAL' , '' ) !== null ){
            cols.push({key: 'paypalbtn', name: 'Pagamento', minWidth: 70, maxWidth: 70, className : 'Paypal', headerClassName : 'Paypal centrato', alt:"Paga con Paypal",
                onRender: (item) => {
                    
                    if( 'PAGAMENTO_RESIDUO' in item && item.PAGAMENTO_RESIDUO !== '')
                    {
                        // let totale =  ( item.NEW_TOT_REALE !== '' && item.NEW_TOT_REALE !== null ) ? item.NEW_TOT_REALE : item.TOTALE;
                        let totale = item.PAGAMENTO_RESIDUO;
                        
                        let user = sessione.get('datiutente');

                        return <Paypal
                            email = {utils.getObjInfoSocieta( 'MAIL_PAYPAL' , '' )}
                            amount = {totale}
                            numfattura = {item.NUMERO_DOCUMENTO}
                            cliente = {user.COD_CLIENTE}
                            metodipagamento = {utils.getObjInfoSocieta( 'PAYPAL_PAGAMENTI_ABILITATI' , '' )}
                            pagamento = {item.ID_MODO_PAGAMENTO}
                        />;
                        
                    } else {
                        return '';
                    }
                }
            });
        }



        return cols;
    }
    
    
    
    restituisciColonneSiti( tipo )
    {

        // tipo : ee / gas
        
        var podpdr = 'POD';
        if( tipo === 'gas'){podpdr = 'PDR';}
        
        var cols = [];

        cols.push({key: 'podpdr', name: podpdr, minWidth: 110, maxWidth: 110, isResizable: false, className : 'mostratutto', headerClassName : 'mostratutto',
            onRender: (item) => {
                if(tipo === 'gas'){
                    return item.PDR;
                }
                else
                {
                    return item.POD;
                }
            }
        });
        
        if( utils.getInfoSocieta( 'FATTURE_DECORRENZA' , true ) !== false ){ 
            cols.push({key: 'decorrenza', name: 'Decorrenza', fieldName: 'DATA_DA', minWidth: 70, maxWidth: 70, isResizable: false });
        }
        
        if( utils.getInfoSocieta( 'FATTURE_NOME_SITO' , true ) !== false ){
            cols.push({key: 'nomesito', name: 'Nome Sito', fieldName: 'DES_SITO', minWidth: 150, maxWidth: 150, isResizable: false, className : 'nascondisotto960 mostratutto',headerClassName : 'nascondisotto960 mostratutto', });
        }
                    
        cols.push({key: 'indirizzosito', name: 'Indirizzo Sito',  minWidth: 200, maxWidth: 450, isResizable: true, className : 'nascondisotto400 mostratutto',headerClassName : 'nascondisotto400 mostratutto',
            onRender: (item) => { 
                return item.INDIRIZZO_SITO + ( item.CAP_SITO!==null ? ', '+item.CAP_SITO : '') + ( (item.NOME_COMUNE!==null && item.NOME_COMUNE!=='') ? ', ' + item.NOME_COMUNE : '' )+ ( (item.NOME_PROVINCIA!==null && item.NOME_PROVINCIA!=='') ? ' (' +item.NOME_PROVINCIA+')' : '' );
            }
        });
 
 
        if( (tipo === 'ee' && utils.getInfoSocieta( 'FATTURE_MODIFICA_SITO' , true ) === true) || (tipo === 'gas' && utils.getInfoSocieta( 'FATTURE_MODIFICA_SITO_GAS' , true ) === true) )
        {
            cols.push({key: 'Menu', name: '', minWidth: 24, maxWidth: 24, className:'bottone', isResizable: false,
                onRender: (item) => {
                    return <div onClick={() => this.apriDialogBox( 'sito'+tipo ,  item )} ><IconButton className='bottoneImmagine' iconProps={{ iconName: 'edit' }} title="Modifica Informazioni Sito" ariaLabel="Modifica Informazioni Sito" /></div>;
                }
            });
        }
        

        if( (tipo === 'ee' && utils.getInfoSocieta( 'FATTURE_SEGNALAZIONI' , false ) === true) || (tipo === 'gas' && utils.getInfoSocieta( 'FATTURE_SEGNALAZIONI' , false ) === true) )
        {
            cols.push({key: 'MenuSegnalazioni', name: '', minWidth: 24, maxWidth: 24, className:'bottone', isResizable: false,
                onRender: (item) => {
                    return <div onClick={() => this.apriDialogBox( 'segnalazioni'+tipo ,  item )} ><IconButton className='bottoneImmagine' iconProps={{ iconName: 'MailReminder' }} title="Segnalazioni" ariaLabel="Segnalazioni" /></div>;
                }
            });
        }
        
        var maxW = 24;
        var classeAutolett = 'bottone';
        
        // gestione da MS381_AC2_CUSTOMIZATION
        if( utils.getInfoSocieta( 'ICONA_AUTOLETTURE_GRANDE' , true ) === true ){
            maxW = 32;
            classeAutolett = 'bottone iconagrande';
        }
        
        // MN - #45338
        // controlla se sono impostati dei giorni di fine mese in cui non si possono inviare le autoletture
        if( utils.mostraBottoneAutolettureSoloUltimiGiorni() === false )
        {
            // popup con messaggio blocco delel autoletture
            cols.push({key: 'MenuAutoletture', name: '', minWidth: maxW, maxWidth: maxW, isResizable: false, className :classeAutolett , headerClassName : classeAutolett,
                onRender: (item) => {
                    // http://10.11.2.51/issues/46619#note-9
                    // //return <div className={(tipo ==='ee' && ( item.TRATTAMENTO_TILP === 'O' || item.TRATTAMENTO_TILP === 'ACEA' ) ) ? 'nascosto' : ''}   
                    return <div className='' 
                        onClick={() => this.apriDialogBox( 'noautolettureultimigiorni' ,  item )} >
                        <IconButton className='bottoneImmagine' iconProps={{ iconName: 'ReceiptUndelivered' }} title="No Autoletture" ariaLabel="No Autoletture" /></div>;
                }
            });
        }
        else if( utils.mostraBottoneAutoletturePerData() === false )
        {
            // popup con messaggio blocco delel autoletture
            cols.push({key: 'MenuAutoletture', name: '', minWidth: maxW, maxWidth: maxW, isResizable: false, className :classeAutolett , headerClassName : classeAutolett,
                onRender: (item) => {
                    // http://10.11.2.51/issues/46619#note-9
                    // // return <div className={(tipo ==='ee' && ( item.TRATTAMENTO_TILP === 'O' || item.TRATTAMENTO_TILP === 'ACEA' ) ) ? 'nascosto' : ''}   
                    return <div className=''
                        onClick={() => this.apriDialogBox( 'noautoletture' ,  item )} >
                        <IconButton className='bottoneImmagine' iconProps={{ iconName: 'ReceiptUndelivered' }} title="No Autoletture" ariaLabel="No Autoletture" /></div>;
                }
            });
            
        }
        
        // #49902 -- finire di sviluppare
        else if( utils.mostraBottoneAutolettureDaDataAData() === false )
        {
            // popup con messaggio blocco delel autoletture
            cols.push({key: 'MenuAutoletture', name: '', minWidth: maxW, maxWidth: maxW, isResizable: false, className :classeAutolett , headerClassName : classeAutolett,
                onRender: (item) => {
                    // http://10.11.2.51/issues/46619#note-9
                    // // return <div className={(tipo ==='ee' && ( item.TRATTAMENTO_TILP === 'O' || item.TRATTAMENTO_TILP === 'ACEA' ) ) ? 'nascosto' : ''}   
                    return <div className=''
                        onClick={() => this.apriDialogBox( 'noautolettureDTD' ,  item )} >
                        <IconButton className='bottoneImmagine' iconProps={{ iconName: 'ReceiptUndelivered' }} title="No Autoletture" ariaLabel="No Autoletture" /></div>;
                }
            });
        }
        
        else if( (tipo === 'ee' && utils.getInfoSocieta( 'FATTURE_AUTOLETTURA' , true ) === true) || (tipo === 'gas' && utils.getInfoSocieta( 'AUTOLETTURE' , true ) === true) )
        {
            var labelcol = '';
            
            if(tipo === 'ee'){
                labelcol = utils.getObjInfoSocieta( 'LABEL_AUTOLETT_EE' , '' );
            }
            if(tipo === 'gas'){
                labelcol = utils.getObjInfoSocieta( 'LABEL_AUTOLETT_GAS' , '' );
            }
            
            
            cols.push({key: 'MenuAutoletture', name: labelcol, minWidth: maxW, maxWidth: maxW, isResizable: false, className :classeAutolett , headerClassName : classeAutolett,
                onRender: (item) => {
                    
                    /** SE FATTURE_AUTOLETTURA=1 && TRATTAMENTO_TILP != 'O' **/
                    // http://10.11.2.51/issues/46619#note-9
                    // //return <div className={(tipo ==='ee' && ( item.TRATTAMENTO_TILP === 'O' || item.TRATTAMENTO_TILP === 'ACEA' ) ) ? 'nascosto' : ''}   
                    return <div className=''
                        onClick={() => this.apriDialogBox( 'autoletture'+tipo ,  item )} >
                        <IconButton className='bottoneImmagine' iconProps={{ iconName: 'NumberedList' }} title="Autoletture" ariaLabel="Autoletture" /></div>;
                }
            });
        }
                
        return cols;
    }
    
    
    restituisciColonneAnagraficaSpedizioni( tipo )
    {
        var podpdr = 'POD';
        if(tipo === 'gas'){podpdr='PDR';}
        
        var cols = [];
        

        cols.push({key: 'elencopod', name:podpdr , minWidth: 110, maxWidth: 110, isResizable: false, className : 'nascondisotto400 mostratutto',headerClassName : 'nascondisotto400 mostratutto' ,
            onRender: (item) => {
                if(tipo === 'gas'){
                    return item.PDR;
                }
                else
                {
                    return item.POD;
                }
            }
        });


        cols.push({key: 'indirizzosito', name: 'Indirizzo Sito',  minWidth: 200, maxWidth: 500, isResizable: true, className : 'mostratutto', headerClassName : 'mostratutto',
            onRender: (item) => {return <TooltipHost content={item.POD} calloutProps={{ gapSpace: 0 }}>
                    {( (item.INDIRIZZO_SPED!==null && item.INDIRIZZO_SPED!=='' ) ? item.INDIRIZZO_SPED + ' '+ ( (item.NUM_CIVICO_SPED!==null && item.NUM_CIVICO_SPED!=='' ) ? item.NUM_CIVICO_SPED : '' ) : '' )+( (item.CAP_SPED!==null && item.CAP_SPED!=='') ? ',  ' +item.CAP_SPED : '') + ((item.NOME_COMUNE_SPED!==null && item.NOME_COMUNE_SPED!=='' ) ?',  ' +item.NOME_COMUNE_SPED : '' )+ ( (item.NOME_PROVINCIA_SPED!==null && item.NOME_PROVINCIA_SPED !=='') ? ' (' +item.NOME_PROVINCIA_SPED+')' : '' )}
                </TooltipHost>; }
        });
        
        
        cols.push({ key: 'Menu', name: '', minWidth: 24, maxWidth: 24, isResizable: false,
            onRender: (item) => {
                
                if( ( tipo==='ee' && utils.getInfoSocieta( 'FATTURE_MODIFICA_SITO' , true ) === true ) || ( tipo==='gas' && utils.getInfoSocieta( 'FATTURE_MODIFICA_SITO_GAS' , true ) === true ) ){
                    return <div onClick={() => this.apriDialogBox( 'indirizzofattura'+tipo , item )} ><IconButton className='bottoneImmagine'  iconProps={{ iconName: 'edit' }} title="Modifica Indirizzo Spedizione" ariaLabel="Modifica Indirizzo Spedizione" /></div>;
                }
            }
        });
        
        
        cols.push({key: 'emailfatt', name: 'Email Fatturazione', minWidth: 110, maxWidth: 110, isResizable: false, className : 'nascondisotto400 mostratutto', headerClassName : 'nascondisotto400 mostratutto',
            onRender: (item) => { return item.EMAIL_FATT; }
        });
        
        
        return cols;
    }
    
    
    
}
export default Azioni;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/Azioni.js